module.exports = __webpack_public_path__ + "img/android-chrome-maskable-192x192.706f3eb4.png";